import { mapEnumToOptions } from '@abp/ng.core';

export enum SupplierDeliveryMode {
  OnSite = 'OnSite',
  OtherSite = 'OtherSite',
  DirectDelivery = 'DirectDelivery',
  PickUp = 'PickUp',
}

export const supplierDeliveryMode = mapEnumToOptions(SupplierDeliveryMode);
